import { useNavigate } from "@solidjs/router"
import { createMemo, Show } from "solid-js"
import { createFragment, type FragmentOf, graphql } from "@/graphql"
import { Button } from "./button"
import { listClass, paginationClass } from "./pagination.css"

export const PageInfoFragment = graphql(`
  fragment PageInfoFragment on PageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
`)

// TODO: Deprecate when graphql spreads all over the codebase
type UrlProps = {
  prevUrl?: string
  nextUrl?: string
  pageInfo?: never
  buildUrl?: never
}

type PageInfoProps = {
  prevUrl?: never
  nextUrl?: never
  pageInfo: FragmentOf<typeof PageInfoFragment> | null | undefined
  buildUrl: (params: { after: string; before: string }) => string
}

type Props = UrlProps | PageInfoProps

export function Pagination(props: Props) {
  const navigate = useNavigate()
  const pageInfo = createFragment(PageInfoFragment, () => props.pageInfo)

  const prevUrl = createMemo(() => {
    if (props.prevUrl) return props.prevUrl
    const info = pageInfo()
    if (!info?.hasPreviousPage || !props.buildUrl) return undefined
    return props.buildUrl({
      after: "",
      before: info.startCursor ?? "",
    })
  })

  const nextUrl = createMemo(() => {
    if (props.nextUrl) return props.nextUrl
    const info = pageInfo()
    if (!info?.hasNextPage || !props.buildUrl) return undefined
    return props.buildUrl({ after: info.endCursor ?? "", before: "" })
  })

  return (
    <nav class={paginationClass}>
      <ul class={listClass}>
        <Show when={prevUrl()}>
          {url => (
            <li>
              <Button
                hue="sand"
                iconName="arrow-left"
                onClick={() => navigate(url())}
              >
                prev
              </Button>
            </li>
          )}
        </Show>

        <Show when={nextUrl()}>
          {url => (
            <li>
              <Button
                hue="sand"
                iconName="arrow-right"
                onClick={() => navigate(url())}
              >
                next
              </Button>
            </li>
          )}
        </Show>
      </ul>
    </nav>
  )
}
